import React from "react";
import Noti from "../Noti";
import { CheckCircleFilled } from "@ant-design/icons";
import { Button } from "antd";

type P_Props = {
  visible: boolean;
  cancel: () => void;
  confirm: () => void;
  title: string;
};

const ModalConfirmPresenter = (props: P_Props) => {
  return (
    <Noti
      visible={props.visible}
      icon={{ color: "browse", children: <CheckCircleFilled style={{ color: "#D38123", fontSize: 64 }} /> }}
      title={""}
      subTitle={props.title}
      actions={
        <>
          <Button
            size="large"
            className="btn btn-outline"
            style={{ width: 200 }}
            onClick={() => {
              props.cancel();
            }}
          >
            Hủy
          </Button>

          <Button
            size="large"
            className="btn"
            style={{ width: 200 }}
            onClick={() => {
              props.confirm();
            }}
          >
            Xác nhận
          </Button>
        </>
      }
    />
  );
};

export default ModalConfirmPresenter;
